/* eslint-disable @typescript-eslint/no-explicit-any */
import omit from 'lodash/omit';
import { FC } from 'react';

import SponsorsBlock from '../../sponsors/SponsorsBlock';
import WorkshopsMatchingBlock from '../../workshops/WorkshopsMatchingBlock';

export type RecapItemProps = {
  /** Ids extraits de la donnée du groupe */
  ids: string[];
  /** Collection dans laquelle résoudre les ids */
  collection: string;
  /** Petit titre affiché au-dessus de la liste */
  label?: string;
  [x: string]: any;
};

/**
 * Utilisateurs affichés via le bloc exposants (SponsorCard + EntityLink), comme sur les pages
 * exhibitors ou le bloc "sponsors" des pages workshop. Le clic redirige vers leur page.
 */
const RecapUsers: FC<RecapItemProps> = (props) => {
  const { ids, collection, label, ...rest } = props;
  return (
    <SponsorsBlock
      ids={ids}
      dataSource={{ kind: 'users', collection }}
      header={label ?? null}
      headerLevel="h4"
      {...rest}
    />
  );
};

/**
 * Sessions (ou workshops) affichées via le bloc utilisé sur les pages speaker/exposant : il va
 * chercher lui-même dans le store les sessions/workshops dont `matchField` vaut un des ids.
 * Le clic redirige vers la page de la session.
 */
const RecapWorkshopSessions: FC<RecapItemProps> = (props) => {
  const { ids, label, matchField = '_id', ...rest } = props;
  return (
    <WorkshopsMatchingBlock
      field={matchField}
      value={ids}
      header={label ?? null}
      headerLevel="h4"
      groupWorkshopsWithSessionsAtTheSameTime
      {...omit(rest, ['collection'])}
    />
  );
};

export const recapItemComponents: Record<string, FC<RecapItemProps>> = {
  users: RecapUsers,
  workshopSessions: RecapWorkshopSessions,
  // tolérance sur le singulier, souvent utilisé en config
  workshopSession: RecapWorkshopSessions,
};
